import { useMemo } from 'react';

// components
import {
  CasEditForm,
  CasRHFTextField,
  CasRHFSwitch,
  IEditForm,
} from 'src/compass/shared/components';

import { CasRHFEmployeeSelect, CasRHFUserSelect } from 'src/compass/application';
// schema
import { EmployeeSchema } from './EmployeeSchema';
import { RHFBranchSelect } from './BranchSelect';

// ----------------------------------------------------------------------

export default function EmployeeForm({ row, onSaved }: IEditForm) {
  const { id } = row || {};

  const defaultValues = useMemo(
    () => (id ? row : { isActive: true }),
    [id, row]
  );

  return (
    <CasEditForm
      defaultValues={defaultValues}
      onSaved={onSaved}
      entity="Employee"
      schema={EmployeeSchema}
    >
      <CasRHFUserSelect name="userId" label="User" includeNoneOption />

      <CasRHFTextField name="shortName" label="Short Name" />

      <RHFBranchSelect name="branchId" label="Branch" />
      <CasRHFEmployeeSelect name="managerEmployeeId" label="Manager" includeNoneOption />

      <CasRHFTextField name="docusignUser" label="Docusign User" />
      <CasRHFTextField name="sceEntryCCEmail" label="SCE CC" />
      <CasRHFTextField
        type="number"
        name="payrollEmpNbr"
        label="Payroll Key (Emp#)"
      />
      <CasRHFSwitch name="isRiskManager" label="Is Risk Manager?" />
      <CasRHFSwitch name="isSalesOrOther" label="Is Sales/Other?" />
      <CasRHFSwitch name="isLRPProcessor" label="Is LRP Processor?" />
      <CasRHFSwitch name="isActive" label="Active" />
    </CasEditForm>
  );
}
